/* import __COLOCATED_TEMPLATE__ from './o-timingpoints-interface.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class OClassesCreatorComponent extends Component 
{
	@service store;
	
	@tracked controlsStart = 31;
	@tracked controlsEnd = 101;
	
	@action
	createFunctionsPoints(browserEvent)
	{	
		browserEvent.preventDefault();
		
		this.store.createRecord('intermediateTimingPoint',
		{
			name: "SI Clear",
			description: "Clear SI",
			EventId: this.args.event,
		}).save();
		this.store.createRecord('intermediateTimingPoint',
		{
			name: "SI Check",
			description: "Check SI",
			EventId: this.args.event,
		}).save();
		this.store.createRecord('intermediateTimingPoint',
		{
			name: "SI Start",
			description: "SI Start",
			EventId: this.args.event,
		}).save();
		this.store.createRecord('intermediateTimingPoint',
		{
			name: "SI Finish",
			description: "SI Finish",
			EventId: this.args.event,
		}).save();
	}
	
	@action
	createControlsPoints(browserEvent)
	{
		browserEvent.preventDefault();
		
		var start = this.controlsStart;
		var end = this.controlsEnd;
		
		for(var i=start;i<=end;i++)
		{
			this.store.createRecord('intermediateTimingPoint',
			{
				name: i,
				description: "Control "+i,
				EventId: this.args.event,
			}).save();
		}
	}
}